export const TIMESHEETS_LOAD_REQUESTED = 'TIMESHEETS_LOAD_REQUESTED';
export const TIMESHEETS_LOAD_SUCCEEDED = 'TIMESHEETS_LOAD_SUCCEEDED';
export const TIMESHEETS_LOAD_FAILED = 'TIMESHEETS_LOAD_FAILED';
export const TIMESHEETS_LOAD_CANCELED = 'TIMESHEETS_LOAD_CANCELED';

export const TIMESHEET_APPROVE_REQUESTED = 'TIMESHEET_APPROVE_REQUESTED';
export const TIMESHEET_APPROVE_SUCCEEDED = 'TIMESHEET_APPROVE_SUCCEEDED';
export const TIMESHEET_APPROVE_FAILED = 'TIMESHEET_APPROVE_FAILED';

export const TIMESHEET_UNAPPROVE_REQUESTED = 'TIMESHEET_UNAPPROVE_REQUESTED';
export const TIMESHEET_UNAPPROVE_SUCCEEDED = 'TIMESHEET_UNAPPROVE_SUCCEEDED';
export const TIMESHEET_UNAPPROVE_FAILED = 'TIMESHEET_UNAPPROVE_FAILED';

export const TIMESHEET_SUBMIT_REQUESTED = 'TIMESHEET_SUBMIT_REQUESTED';
export const TIMESHEET_SUBMIT_SUCCEEDED = 'TIMESHEET_SUBMIT_SUCCEEDED';
export const TIMESHEET_SUBMIT_FAILED = 'TIMESHEET_SUBMIT_FAILED';

export const TIMESHEET_MULTIPLE_SUBMIT_REQUESTED =
    'TIMESHEET_MULTIPLE_SUBMIT_REQUESTED';
export const TIMESHEET_MULTIPLE_SUBMIT_SUCCEEDED =
    'TIMESHEET_MULTIPLE_SUBMIT_SUCCEEDED';
export const TIMESHEET_MULTIPLE_SUBMIT_FAILED =
    'TIMESHEET_MULTIPLE_SUBMIT_FAILED';

export const TIMESHEET_DELETE_REQUESTED = 'TIMESHEET_DELETE_REQUESTED';
export const TIMESHEET_DELETE_SUCCEEDED = 'TIMESHEET_DELETE_SUCCEEDED';
export const TIMESHEET_DELETE_FAILED = 'TIMESHEET_DELETE_FAILED';

export const TIMESHEETS_SET = 'TIMESHEETS_SET';

export const DATAPAY_HOLIDAY_DAYS_EXPORT_REQUESTED =
    'DATAPAY_HOLIDAY_DAYS_EXPORT_REQUESTED';
export const DATAPAY_HOLIDAY_DAYS_EXPORT_SUCCEEDED =
    'DATAPAY_HOLIDAY_DAYS_EXPORT_SUCCEEDED';
export const DATAPAY_HOLIDAY_DAYS_EXPORT_FAILED =
    'DATAPAY_HOLIDAY_DAYS_EXPORT_FAILED';
